var documentComponentJS = (function() {
	
	function checkDownloadsTypes(){
		$('.downloads-item-links').each(function(i,e){
			var elem = $(e);

			elem.find('a').each(function(i,l){
				checkURL(this);
			});
		});
	}

	function checkURL(l){
		var link = $(l);
		
		if ( link.attr('href').indexOf('files') > -1 ) {
			if ( link.attr('href').split('.')[1] ) {
				if (link.attr('href').substr(link.attr('href').lastIndexOf('.') + 1) == 'zip') {
					link.html(link.attr('data-attr'));
				} else {
					link.html(link.attr('href').substr(link.attr('href').lastIndexOf('.') + 1));
				}
			}
		} else if ( link.attr('href') != 0 )  {
			link.html('pdf');
		}
	}
	return{
		checkDownloadsTypes: checkDownloadsTypes,
		checkURL: checkURL
	}
})();

window.documentComponentJS = documentComponentJS;

$(document).ready(function(){
	window.documentComponentJS.checkDownloadsTypes();
});

export default documentComponentJS;